import { code128Modules } from '@wms/domain';
import { useMemo } from 'react';

/** Code 128 as SVG bars with quiet zones; scales to its box (labels set its width and height). */
export function Barcode({ value, className }: { value: string; className?: string }) {
  const bars = useMemo(() => {
    const modules = code128Modules(value);
    const out: { x: number; w: number }[] = [];
    for (let i = 0; i < modules.length; ) {
      if (modules[i] === '1') {
        let w = 1;
        while (modules[i + w] === '1') w++;
        out.push({ x: i, w });
        i += w;
      } else i++;
    }
    return { width: modules.length, bars: out };
  }, [value]);
  const quiet = 10;
  return (
    <svg className={className} viewBox={`0 0 ${bars.width + quiet * 2} 40`} preserveAspectRatio="none" role="img" aria-label={value}>
      {bars.bars.map((b) => (
        <rect key={b.x} x={b.x + quiet} y={0} width={b.w} height={40} fill="#000" />
      ))}
    </svg>
  );
}
